import React, { useEffect, useState } from 'react'

import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'


import {  useDispatch, useSelector } from 'react-redux';

import { 
  
  obtenerDatosLlaves   
} from "../../store/actions/encargado-cia-action";
import CargarArchivo from './CargarArchivo';
import CargasPrevias from './cargas-previas';



const VerificaIngresoPago = () => {



  // El hook useSelector (redux) permite acceder al state en nuestro store.
  const data_encargado_cia = useSelector(state => state.encargado_compania);
  const { antecedentesCasos, llaves} = data_encargado_cia;
  const dispatch = useDispatch();


  return (
    <Container>
      <Card className='mt-2'>
        <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >Verificar Ingreso de Pagos a Caja</Card.Header>
        <Card.Body>
      <CargarArchivo />
         <CargasPrevias/> 
        </Card.Body>
      </Card>
    </Container>
  )
}
export default VerificaIngresoPago
